import * as desktopRoutes from 'web/routes';
import * as mobileRoutes from 'mobile/routes';
import * as sharedRoutes from 'shared/routes';

/**
Home
Intro
Playlist
 */

/**
 * public 과 grade 값으로 페이지에 권한을 지정할 수 있음
 * 기본값 = { public: false }; === 로그인이 필요한 페이지
 *  - children에 routes를 담고있는 Object에 public 값을 true로 설정하면 비로그인으로 접근 가능한 페이지로 설정
 *  - 기본값(로그인이 필요한 페이지)에서 { grade: Number } 값을 설정하면 해당 등급 '이상'의 유저만 접근 가능한 페이지로 설정
 *  ( grade 1은 로그인 전제이기 때문에 설정할 필요 없음 )
 *
 * const grade = {
 *  0: '비로그인',
 *  1: '무료회원',
 *  2: '유료회원',
 *  3: '구매대기',
 * }
 *
 */

// export const userPurchase = {
//   NONE: {
//     title: '비회원',
//     grade: 0,
//   },
//   FREE: {
//     title: '무료회원',
//     grade: 1,
//   },
//   PAID: {
//     title: '유료회원',
//     grade: 2,
//   },
//   STANDING: {
//     title: '구매대기',
//     grade: 3,
//   },
// };

export const gradeSet = {
  all: {
    value: 'ALL',
    grade: ['NONE', 'FREE', 'PAID', 'STANDING'], // 허용하는 userPurchase List
    comment: '항시 노출',
  },
  login: {
    value: 'LOGIN',
    grade: ['FREE', 'PAID', 'STANDING'],
    comment: '로그인 유저에게만 노출',
  },
  guest: {
    value: 'GUEST',
    grade: ['NONE'],
    comment: '비로그인 유저에게만 노출',
  },
  paid: {
    value: 'PAID',
    grade: ['PAID'],
    comment: '유료 회원에게만 노출',
  },
};

export default {
  menu: [
    {
      id: 'HOME',
      title: '닥터뮤지',
      path: '',
      exact: true,
      display: {
        lnb: true,
        gradeSet: gradeSet.all,
        icon: 'ic-lecture',
        hoverIcon: 'ic-lecture-2',
      },

      // children: routes.Home,
      desktop: desktopRoutes.Home,
      mobile: mobileRoutes.Home,
      // webplayer: true,
      public: true,
    },

    {
      id: 'STUDY',
      title: '스터디',
      path: 'study',
      children: [
        {
          title: 'item',
          path: ':id',
          children: [
            {
              title: '곡 상세',
              path: 'detail',
              desktop: desktopRoutes.StudyDetail,
              mobile: mobileRoutes.FreeExperience,
            },
            {
              title: '강의',
              path: 'lecture',
              children: [
                {
                  title: '강의',
                  path: ':key',
                  exact: true,
                  desktop: desktopRoutes.StudyLecture,
                  mobile: mobileRoutes.DesktopOnly,
                },
              ],
            },
            {
              title: '팝송',
              path: 'song',
              // children: desktopRoutes.StudySong,
              desktop: desktopRoutes.StudySong,
              mobile: mobileRoutes.DesktopOnly,
            },
            {
              title: '듣기',
              path: 'listen',
              children: [
                {
                  title: '듣기',
                  path: ':key',
                  exact: true,
                  // children: desktopRoutes.StudyListen,
                  desktop: desktopRoutes.StudyListen,
                  mobile: mobileRoutes.DesktopOnly,
                },
              ],
            },
            {
              title: '말하기',
              path: 'speak',
              children: [
                {
                  title: '말하기',
                  path: ':key',
                  exact: true,
                  // children: desktopRoutes.StudySpeak,
                  desktop: desktopRoutes.StudySpeak,
                  mobile: mobileRoutes.DesktopOnly,
                },
              ],
            },
            {
              title: '실전',
              path: 'practice',
              exact: true,
              // children: desktopRoutes.StudyPractice,
              desktop: desktopRoutes.StudyPractice,
              mobile: mobileRoutes.DesktopOnly,
            },
            {
              title: '실전',
              path: 'practice',
              children: [
                {
                  title: '실전',
                  path: ':key',
                  exact: true,
                  // children: desktopRoutes.StudyPracticeStudy,
                  desktop: desktopRoutes.StudyPracticeStudy,
                  mobile: mobileRoutes.DesktopOnly,
                },
                {
                  title: '실전',
                  path: ':key',
                  children: [
                    {
                      title: '실전',
                      path: 'result',
                      // children: desktopRoutes.StudyPracticeResult,
                      desktop: desktopRoutes.StudyPracticeResult,
                      mobile: mobileRoutes.DesktopOnly,
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 'LECTURE_LIST',
      title: '강의',
      path: 'list',
      webplayer: true,
      display: {
        lnb: true,
        gradeSet: gradeSet.all,
        icon: 'ic-lecture',
        hoverIcon: 'ic-lecture-2',
      },
      // children: desktopRoutes.LectureList,
      desktop: desktopRoutes.LectureList,
      mobile: mobileRoutes.DesktopOnly,
    },
    {
      id: 'ALL_LIST',
      title: '팝송',
      path: 'popsong',
      webplayer: true,
      display: {
        lnb: true,
        gradeSet: gradeSet.all,
        icon: 'ic-popsong',
        hoverIcon: 'ic-popsong-2',
      },
      // children: desktopRoutes.ByType,
      desktop: desktopRoutes.ByType,
      mobile: mobileRoutes.DesktopOnly,
    },
    {
      id: 'COPYRIGHT_SONGS_LIST',
      title: '팝송 저작권 리스트',
      path: 'songscopyright',
      webplayer: true,
      // children: desktopRoutes.ByType,
      desktop: desktopRoutes.SongsCopyRight,
      mobile: mobileRoutes.SongsCopyRight,
    },
    {
      id: 'PLAYLIST',
      title: '플레이리스트',
      path: 'player',
      // display: { lnb: true },
      children: [
        {
          title: '장르로 찾기',
          path: 'genre',
          // children: desktopRoutes.PlayerGenre,
          desktop: desktopRoutes.PlayerGenre,
          mobile: mobileRoutes.DesktopOnly,
          webplayer: true,
        },
        {
          title: '무드로 찾기',
          path: 'mood',
          // children: desktopRoutes.PlayerMood,
          desktop: desktopRoutes.PlayerMood,
          mobile: mobileRoutes.DesktopOnly,
          webplayer: true,
        },
        {
          title: '곡 검색',
          path: 'search',
          // children: desktopRoutes.PlayerSearch,
          desktop: desktopRoutes.PlayerSearch,
          mobile: mobileRoutes.DesktopOnly,
          webplayer: true,
        },
        {
          title: '곡',
          path: ':id',
          children: [
            {
              title: '곡 감상',
              path: 'play',
              // children: desktopRoutes.PlayerPlay,
              desktop: desktopRoutes.PlayerPlay,
              mobile: mobileRoutes.DesktopOnly,
              webplayer: true,
              isPlayer: true,
            },
          ],
        },
      ],
    },
    // {
    //   id: 'MY_PAGE',
    //   title: '내 학습',
    //   path: 'my',
    //   exact: true,
    //   display: { lnb: true },
    //   children: desktopRoutes.MyStatus,
    //   webplayer: true,
    // },
    {
      id: 'MY_STUDY',
      title: '내 학습 내역',
      path: 'mystudy',
      display: {
        lnb: true,
        gradeSet: gradeSet.login,
        icon: 'ic-mylist',
        hoverIcon: 'ic-mylist-2',
      },
      children: [
        {
          id: 'MY_STUDY',
          title: '내 학습',
          path: 'status',
          // children: desktopRoutes.MyStudyStatus,
          desktop: desktopRoutes.MyStudyStatus,
          mobile: mobileRoutes.DesktopOnly,
          webplayer: true,
        },
        {
          title: '보관함',
          path: 'locker',
          children: [
            {
              title: '가사',
              path: 'script',
              // children: desktopRoutes.MyStudyLockerScript,
              desktop: desktopRoutes.MyStudyLockerScript,
              mobile: mobileRoutes.DesktopOnly,
              webplayer: true,
              isPlayer: true,
            },
            {
              title: '단어',
              path: 'dictionary',
              exact: true,
              // children: desktopRoutes.MyStudyLockerDictionary,
              desktop: desktopRoutes.MyStudyLockerDictionary,
              mobile: mobileRoutes.DesktopOnly,
              webplayer: true,
              isPlayer: true,
            },
            {
              title: '단어',
              path: 'dictionary',
              children: [
                {
                  title: '단어',
                  path: 'memorization',
                  // children: desktopRoutes.MyStudyLockerDictionaryMemorization,
                  desktop: desktopRoutes.MyStudyLockerDictionaryMemorization,
                  mobile: mobileRoutes.DesktopOnly,
                  webplayer: true,
                  isPlayer: true,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 'MY',
      title: '내 정보',
      path: 'my',
      children: [
        {
          id: 'MY_SETTING',
          title: '설정',
          path: 'setting',
          exact: true,
          // children: desktopRoutes.MySetting,
          desktop: desktopRoutes.MySetting,
          // mobile: desktopRoutes.MySetting,
          mobile: mobileRoutes.MySetting,
          webplayer: false,
        },
        {
          id: 'MY_SETTING',
          title: '설정',
          path: 'setting',
          children: [
            {
              id: 'MY_SETTING_SECESSION',
              title: '탈퇴',
              path: 'drop',
              // children: desktopRoutes.MyDropOut,
              desktop: desktopRoutes.MyDropOut,
              mobile: mobileRoutes.DesktopOnly,
              webplayer: false,
            },
          ],
        },
        {
          id: 'MY_CHALLENGE',
          title: '챌린지',
          path: 'challenge',

          children: [
            {
              id: 'MY_CHALLENGE',
              title: '챌린지',
              path: 'intro',
              desktop: desktopRoutes.MyChallenge,
              mobile: mobileRoutes.MyChallenge,
              webplayer: false,
            },
            {
              id: 'MY_CHALLENGE',
              title: '미션 체크',
              path: 'mission',
              desktop: desktopRoutes.MyMission,
              mobile: mobileRoutes.MyMission,
              webplayer: false,
              exact: true,
            },
            // {
            //   id: 'MY_CHALLENGE',
            //   title: '챌린지',
            //   path: 'mission',
            //   children: [
            //     {
            //       id: 'MY_CHALLENGE',
            //       title: '미션 체크',
            //       path: ':day',
            //       desktop: desktopRoutes.MyMission,
            //       mobile: mobileRoutes.MyMission,
            //       webplayer: false,
            //     },
            //   ],
            // },
            {
              id: 'MY_CHALLENGE',
              title: '진행 내역',
              path: 'progress',
              desktop: desktopRoutes.MyProgress,
              mobile: mobileRoutes.MyProgress,
              webplayer: false,
            },
            {
              id: 'MY_CHALLENGE',
              title: '필요 서류 등록',
              path: 'paper',
              desktop: desktopRoutes.MyNeedPaper,
              mobile: mobileRoutes.MyNeedPaper,
              webplayer: false,
            },
          ],
        },
        {
          id: 'MY_PURCHASE',
          title: '구매내역',
          path: 'purchase',
          children: [
            {
              id: 'MY_PURCHASE',
              title: '구매내역',
              path: 'history',
              desktop: desktopRoutes.MyPurchaseHistory,
              mobile: mobileRoutes.PurchaseHistory,
              webplayer: false,
            },
          ],
          // desktop: desktopRoutes.MySetting,
          // mobile: mobileRoutes.Home,
          // webplayer: true,
        },
        {
          id: 'MY_COUPON',
          title: '쿠폰',
          path: 'coupon',
          children: [
            {
              id: 'MY_PURCHASE_LIST',
              title: '쿠폰리스트',
              path: 'list',
              desktop: desktopRoutes.MyCouponList,
              mobile: desktopRoutes.MyCouponList,
              webplayer: false,
            },
          ],
          // desktop: desktopRoutes.MySetting,
          // mobile: mobileRoutes.Home,
          // webplayer: true,
        },
      ],
    },

    {
      id: 'INTRODUCE',
      title: '서비스 소개',
      path: 'introduce',
      public: true,
      children: [
        {
          id: 'TUTORIAL',
          title: '맛보기',
          path: 'tutorial',
          exact: true,
          desktop: desktopRoutes.Experience,
          mobile: mobileRoutes.Tutorial,
          webplayer: true,
          public: true,
        },
        {
          id: 'PURCHASE',
          title: '구매',
          path: 'purchase',
          children: [
            {
              id: 'PURCHASE_PAY',
              title: '결제',
              path: 'pay',
              children: [
                {
                  id: 'PURCHASE_PAY_PRODUCT',
                  title: '결제',
                  path: 'products',
                  exact: true,
                  desktop: desktopRoutes.PruchasePayProducts,
                  mobile: mobileRoutes.PurchaseProducts,
                },
                {
                  id: 'PURCHASE_FAILURE',
                  title: '구매실패',
                  path: 'failure',
                  desktop: desktopRoutes.PruchaseFailure,
                  mobile: mobileRoutes.PurchaseFailure,
                  webplayer: false,
                },
                {
                  id: 'PURCHASE_SUCCESS',
                  title: '구매성공',
                  path: 'success',
                  desktop: desktopRoutes.PruchaseSuccess,
                  mobile: mobileRoutes.PurchaseSuccess,
                  webplayer: false,
                },
                {
                  id: 'PURCHASE_PAY_PRODUCT_DETAIL',
                  title: '결제',
                  path: 'products',
                  children: [
                    {
                      id: 'PURCHASE_PAY_PRODUCT_DETAIL',
                      title: '결제',
                      path: ':item',
                      exact: true,
                      desktop: desktopRoutes.PruchasePayProductDetail,
                      mobile: mobileRoutes.PurchaseProduct,
                    },
                  ],
                },
                {
                  id: 'PURCHASE_REPAY_PRODUCT_DETAIL',
                  title: '결제',
                  path: 'cs',
                  children: [
                    {
                      id: 'PURCHASE_REPAY_PRODUCT',
                      title: '결제',
                      path: 'products',
                      children: [
                        {
                          id: 'PURCHASE_REAY_PRODUCT_DETAIL',
                          title: '결제',
                          path: ':item',
                          exact: true,
                          desktop: desktopRoutes.PruchaseRepayProductDetail,
                          mobile: mobileRoutes.PurchaseRepayProductDetail,
                        },
                      ],
                    },
                  ],
                },
              ],
              // webplayer: true,
            },
            {
              id: 'PURCHASE_HISTORY',
              title: '구매내역',
              path: 'history',
              desktop: desktopRoutes.PruchaseHistory,
              mobile: mobileRoutes.PurchaseHistory,
              webplayer: true,
            },
          ],
        },
      ],
    },
    // {
    //   id: 'SELLING',
    //   title: '셀링',
    //   path: 'event',
    //   children: [
    //     {
    //       id: 'WEB_EMARKETING',
    //       title: 'Web Marketing A',
    //       path: 'facebook',
    //       exact: true,
    //       children: [
    //         {
    //           id: 'WEB_EMARKETING',
    //           title: 'Web Marketing A',
    //           path: 'preorder',
    //           exact: true,
    //           desktop: desktopRoutes.FacebookSellingWebB,
    //           mobile: desktopRoutes.FacebookSellingWebB,
    //           public: true,
    //           webplayer: false,
    //         },
    //         {
    //           id: 'WEB_EMARKETING',
    //           title: 'Web Marketing NSDA Pops Banner Only',
    //           path: 'nsda_pops',
    //           exact: true,
    //           desktop: desktopRoutes.FacebookSellingWebNSDAPops,
    //           mobile: desktopRoutes.FacebookSellingWebNSDAPops,
    //           public: true,
    //           webplayer: false,
    //         },
    //       ],
    //       public: true,
    //       webplayer: false,
    //     },

    //     {
    //       id: 'WEB_EMARKETING',
    //       title: 'Web Marketing A',
    //       path: 'preorder',
    //       exact: true,
    //       desktop: desktopRoutes.SellingWebB,
    //       // for development
    //       mobile: desktopRoutes.SellingWebB,
    //       public: true,
    //       webplayer: false,
    //     },
    //     {
    //       id: 'WEB_EMARKETING',
    //       title: 'Web Marketing A',
    //       path: 'preorderlecture',
    //       exact: true,
    //       desktop: desktopRoutes.SellingWebLecture,
    //       // for development
    //       mobile: desktopRoutes.SellingWebLecture,
    //       public: true,
    //       webplayer: false,
    //     },
    //     {
    //       id: 'WEB_EMARKETING',
    //       title: 'Web Marketing A',
    //       path: 'preorderfunction',
    //       exact: true,
    //       desktop: desktopRoutes.SellingWebFunction,
    //       // for development
    //       mobile: desktopRoutes.SellingWebFunction,
    //       public: true,
    //       webplayer: false,
    //     },
    //     {
    //       id: 'WEB_EMARKETING',
    //       title: 'Web Marketing A',
    //       path: 'preorderstudy',
    //       exact: true,
    //       desktop: desktopRoutes.SellingWebStudy,
    //       // for development
    //       mobile: desktopRoutes.SellingWebStudy,
    //       public: true,
    //       webplayer: false,
    //     },

    //     {
    //       id: 'WEB_EMARKETING',
    //       title: 'Web Marketing for Youtube Banner Only',
    //       path: 'preordery',
    //       exact: true,
    //       desktop: desktopRoutes.SellingWebB,
    //       // for development
    //       mobile: desktopRoutes.SellingWebB,
    //       public: true,
    //       webplayer: false,
    //     },
    //     {
    //       id: 'WEB_EMARKETING',
    //       title: 'Web Marketing for Youtube Banner Only Sample',
    //       path: 'preordery_sample',
    //       exact: true,
    //       desktop: desktopRoutes.SellingWebY,
    //       // for development
    //       mobile: desktopRoutes.SellingWebY,
    //       public: true,
    //       webplayer: false,
    //     },

    //     {
    //       id: 'WEB_EMARKETING',
    //       title: 'Web Marketing for Youtube Banner Only',
    //       path: 'preorderlecturebenefit',
    //       exact: true,
    //       desktop: desktopRoutes.SellingWebBenefit,
    //       // for development
    //       mobile: desktopRoutes.SellingWebBenefit,
    //       public: true,
    //       webplayer: false,
    //     },

    //     {
    //       id: 'WEB_EMARKETING',
    //       title: 'Web Marketing B',
    //       path: 'preordersp',
    //       exact: true,
    //       desktop: desktopRoutes.SellingWebSP,
    //       // for development
    //       mobile: desktopRoutes.SellingWebSP,
    //       public: true,
    //       webplayer: false,
    //     },
    //     {
    //       id: 'WEB_EMARKETING',
    //       title: 'Web Marketing Quiz Banner Only',
    //       path: 'preorderquiz',
    //       exact: true,
    //       desktop: desktopRoutes.SellingWebQuiz,
    //       // for development
    //       mobile: desktopRoutes.SellingWebQuiz,
    //       public: true,
    //       webplayer: false,
    //     },
    //     {
    //       id: 'WEB_EMARKETING',
    //       title: 'Web Marketing Quiz B Banner Only',
    //       path: 'preorderquizb',
    //       exact: true,
    //       desktop: desktopRoutes.SellingWebQuizB,
    //       // for development
    //       mobile: desktopRoutes.SellingWebQuizB,
    //       public: true,
    //       webplayer: false,
    //     },
    //     {
    //       id: 'WEB_EMARKETING',
    //       title: 'Web Marketing NSDA Pops Banner Only',
    //       path: 'nsda_pops',
    //       exact: true,
    //       desktop: desktopRoutes.SellingWebNSDAPops,
    //       // for development
    //       mobile: desktopRoutes.SellingWebNSDAPops,
    //       public: true,
    //       webplayer: false,
    //     },
    //     {
    //       id: 'WEB_EMARKETING',
    //       title: 'Web Marketing NSDA Pops2 Banner Only',
    //       path: 'nsda_pops2',
    //       exact: true,
    //       desktop: desktopRoutes.SellingWebNSDAPops2,
    //       // for development
    //       mobile: desktopRoutes.SellingWebNSDAPops2,
    //       public: true,
    //       webplayer: false,
    //     },
    //     {
    //       id: 'WEB_EMARKETING',
    //       title: 'Web Marketing NSDA Quiz Banner Only',
    //       path: 'nsda_quiz',
    //       exact: true,
    //       desktop: desktopRoutes.SellingWebNSDAQuiz,
    //       // for development
    //       mobile: desktopRoutes.SellingWebNSDAQuiz,
    //       public: true,
    //       webplayer: false,
    //     },
    //     {
    //       id: 'WEB_EMARKETING',
    //       title: 'Web Marketing NSDA Alarm Banner Only',
    //       path: 'nsda_alarm',
    //       exact: true,
    //       desktop: desktopRoutes.SellingWebNSDAAlarm,
    //       // for development
    //       mobile: desktopRoutes.SellingWebNSDAAlarm,
    //       public: true,
    //       webplayer: false,
    //     },
    //     {
    //       id: 'WEB_EMARKETING',
    //       title: 'Web Marketing NSDA Doctor Banner Only',
    //       path: 'nsda_doctor',
    //       exact: true,
    //       desktop: desktopRoutes.SellingWebNSDADoctor,
    //       // for development
    //       mobile: desktopRoutes.SellingWebNSDADoctor,
    //       public: true,
    //       webplayer: false,
    //     },

    //     ///// POPUP EVENT PAGE
    //     {
    //       id: 'POPUP_EVENT_PAGE',
    //       title: 'from Popup Envet',
    //       path: 'popup',
    //       children: [
    //         /// Visual, 순서 변경
    //         {
    //           id: 'POPUP_EVENT_PAGE_2',
    //           title: 'nsda_pops3 from Popup Envet',
    //           path: 'nsda_pops3',
    //           exact: true,
    //           desktop: desktopRoutes.SellingWebPopupNSDAPops3,
    //           // for development
    //           mobile: desktopRoutes.SellingWebPopupNSDAPops3,
    //           public: true,
    //           webplayer: false,
    //         },
    //         {
    //           id: 'POPUP_EVENT_PAGE_3',
    //           title: 'nsda_quiz2 from Popup Envet',
    //           path: 'nsda_quiz2',
    //           exact: true,
    //           desktop: desktopRoutes.SellingWebPopupNSDAQuiz2,
    //           // for development
    //           mobile: desktopRoutes.SellingWebPopupNSDAQuiz2,
    //           public: true,
    //           webplayer: false,
    //         },

    //         /// DONE
    //         {
    //           id: 'POPUP_EVENT_PAGE_1',
    //           title: '10m from Popup Envet',
    //           path: '10m',
    //           exact: true,
    //           desktop: desktopRoutes.SellingWebPopup10m,
    //           // for development
    //           mobile: desktopRoutes.SellingWebPopup10m,
    //           public: true,
    //           webplayer: false,
    //         },
    //         {
    //           id: 'POPUP_EVENT_PAGE_4',
    //           title: 'nsda_alarm from Popup Envet',
    //           path: 'nsda_alarm',
    //           exact: true,
    //           desktop: desktopRoutes.SellingWebPopupNSDAAlarm,
    //           // for development
    //           mobile: desktopRoutes.SellingWebPopupNSDAAlarm,
    //           public: true,
    //           webplayer: false,
    //         },
    //         {
    //           id: 'POPUP_EVENT_PAGE_5',
    //           title: 'nsda_doctor from Popup Envet',
    //           path: 'nsda_doctor',
    //           exact: true,
    //           desktop: desktopRoutes.SellingWebPopupNSDADoctor,
    //           // for development
    //           mobile: desktopRoutes.SellingWebPopupNSDADoctor,
    //           public: true,
    //           webplayer: false,
    //         },
    //       ],
    //     },
    //   ],
    // },
    {
      id: 'GOODMORNINGPOPS',
      title: '굳모닝팝스',
      path: 'pops',
      exact: true,
      desktop: desktopRoutes.SellingWebP,
      mobile: desktopRoutes.SellingWebP,
      public: true,
    },

    {
      id: 'APP_DOWNLOAD',
      title: '앱 다운로드',
      path: 'appdownload',
      exact: true,
      desktop: desktopRoutes.Experience,
      mobile: mobileRoutes.AppDownload,
      webplayer: true,
      public: true,
    },
    {
      id: 'FREE_EXPERIENCE',
      title: '7일 무료 체험',
      path: 'experience',
      exact: true,
      desktop: desktopRoutes.Experience,
      mobile: mobileRoutes.DesktopOnly,
      webplayer: true,
      public: true,
    },
    {
      id: 'BUY_MEMBERSHIP',
      title: '멤버쉽 구매',
      path: 'membership',
      exact: true,
      desktop: desktopRoutes.Membership,
      mobile: mobileRoutes.DesktopOnly,
      webplayer: true,
      public: true,
    },
    {
      id: 'SETTING',
      title: '사용자 설정',
      path: 'setting',
      exact: true,
      desktop: desktopRoutes.Setting,
      mobile: mobileRoutes.DesktopOnly,
      webplayer: true,
      public: true,
    },
    {
      id: 'CUSTOMER',
      title: '고객센터',
      path: 'customer',
      exact: true,
      desktop: desktopRoutes.Customer,
      mobile: mobileRoutes.Customer,
      webplayer: false,
      public: true,
    },
    {
      id: 'CUSTOMER.Special',
      title: '고객센터',
      path: 'customer/special',
      desktop: desktopRoutes.Customer,
      mobile: mobileRoutes.Customer,
      webplayer: false,
      public: true,
    },
    {
      id: 'MANUAL',
      title: '고객센터',
      path: 'manual',
      exact: true,
      desktop: desktopRoutes.Manual,
      mobile: mobileRoutes.Manual,
      webplayer: false,
      public: true,
    },
    {
      id: 'MEMBERBLOCK',
      title: '무료회원 강의 제한',
      path: 'memberblock',
      exact: true,
      desktop: desktopRoutes.MemberBlock,
      mobile: mobileRoutes.Home,
      webplayer: false,
      public: true,
    },
    {
      id: 'privacy',
      title: '개인정보',
      path: 'privacy',
      children: [
        {
          id: 'privacy_policy',
          title: '취급방침',
          path: 'policy',
          exact: true,
          desktop: desktopRoutes.PrivacyPolicy,
          mobile: desktopRoutes.PrivacyPolicy,
        },
        {
          id: 'privacy_policy',
          title: '개인정보 수집 이용 동의',
          path: 'policy',
          children: [
            {
              id: 'privacy_policy_device',
              title: '디바이스',
              path: 'device',
              desktop: desktopRoutes.PrivacyPolicyDevice,
              mobile: desktopRoutes.PrivacyPolicyDevice,
            },
          ],
        },
      ],
    },

    {
      id: 'info',
      title: '관련정보',
      path: 'info',
      children: [
        {
          id: 'info_terms',
          title: '이용약관',
          path: 'terms',
          exact: true,
          desktop: desktopRoutes.InfoTermAndPolicy,
          mobile: desktopRoutes.InfoTermAndPolicy,
        },
        {
          id: 'info_term',
          title: '이용약관 & 개인정보 취급방침',
          path: 'terms',
          exact: true,
          desktop: desktopRoutes.InfoTerm,
          mobile: desktopRoutes.InfoTerm,
        },
        {
          id: 'info_term',
          title: '이용약관',
          path: 'term',
          exact: true,
          desktop: desktopRoutes.InfoTerm,
          mobile: desktopRoutes.InfoTerm,
        },
        {
          id: 'info_policy',
          title: '개인정보 취급방침',
          path: 'policy',
          desktop: desktopRoutes.InfoPolicy,
          mobile: desktopRoutes.InfoPolicy,
        },
        {
          id: 'info_license',
          title: '개인정보 취급방침',
          path: 'license',
          desktop: desktopRoutes.InfoLicense,
          mobile: desktopRoutes.InfoLicense,
        },
      ],
    },

    {
      id: 'testss',
      title: 'testss',
      path: 'testss',
      desktop: mobileRoutes.Test,
      mobile: mobileRoutes.Test,
    },

    {
      id: 'selling-new',
      title: '셀링페이지',
      path: 'selling',
      desktop: sharedRoutes.Selling,
      mobile: sharedRoutes.Selling,
    },
    {
      id: 'selling-new',
      title: '뉴메인페이지',
      path: 'drmuzy',
      desktop: sharedRoutes.Drmuzy,
      mobile: sharedRoutes.Drmuzy,
    },
    {
      id: 'drmuzy-new',
      title: '닥터뮤지란',
      path: 'about',
      desktop: desktopRoutes.MobileOnly,
      mobile: sharedRoutes.IsDrMuzy,
    },
    {
      id: 'free-experience',
      title: '닥터뮤지란',
      path: 'freeexperience',
      desktop: desktopRoutes.MobileOnly,
      mobile: sharedRoutes.FreeExperience,
    },
  ],
};
